import React from "react";
import { RecapitulationReportCard } from "./RecapitulationReportCard";
import { RecapitulationReportUIProvider } from "./RecapitulationReportUIContext";

export function RecapitulationReportPage({ history, match }) {
  const recapitulationReportUIEvents = {
    newRecapitulationReportButtonClick: () => {
      history.push("/admin/consolidationReport/new");
    },
    openEditRecapitulationReportPage: id => {
      history.push(`/admin/consolidationReport/${id}/detail`);
    },
    openRecapitulationReportFilePage: id => {
      history.push(`/admin/consolidationReport/file/${id}`);
    }
  };

  return (
    <RecapitulationReportUIProvider
      recapitulationReportUIEvents={recapitulationReportUIEvents}
    >
      <RecapitulationReportCard history={history} match={match} />
    </RecapitulationReportUIProvider>
  );
}
